import React from 'react'
import GiftContext from './context'
import { getFormTexts, getAgreements, getAgreements2 } from '../components/gift-form/texts'
import { getLargeFormTexts, getLargeAgreements, getLargeAgreements2 } from '../components/gift-large-form/texts'
import { validateForm } from '../utils/validation'
import { validateLargeForm } from '../utils/validation-large-form'
import { getUserLocation } from '../components/common/get-user-location'

const mainState = {
  // main states
  mode: null,
  lang: null,
  code: null,
  // list of errors
  errors: [],
  // form field values
  email: '',
  phone: '',
  password: '',
  rpassword: '',
  name: '',
  privacyPolicy: false,
  privacyPolicy2: false,
  flownBefore: false,
  userSmsCode: '',
  amountSpent: null,
  // additional data
  realSmsCode: null,
  isGdpr: null,
}

const largeFormState = {
  // main states
  mode: null,
  lang: null,
  code: null,
  // list of errors
  errors: [],
  // form field values
  email: '',
  phone: '',
  password: '',
  name: '',
  country: '',
  state: '',
  privacyPolicy: false,
  privacyPolicy2: false,
  userSmsCode: '',
  // additional data
  realSmsCode: null,
  isGdpr: null,
  dynamicValidation: ''
}

class GiftProvider extends React.Component {
  state = this.props.isLargeForm ? largeFormState : mainState

  componentDidMount() {
    const geo = getUserLocation()
    this.setState({ isGdpr: geo.eu })
  }

  updateState = state => {
    this.setState(prevState => ({ ...prevState, ...state }))
  }

  validate = formState => {
    this.cleanErrors()
    const errors = this.props.isLargeForm ? validateLargeForm(formState, this.state) : validateForm(formState, this.state)

    this.setState({ errors })

    return errors.length === 0
  }

  cleanErrors = () => {
    this.setState({ errors: [] })
  }

  handleChangeField = (field, value) => {
    this.cleanErrors()
    this.setState({
      [field]: value,
    })
  }

  renderError = error => {
    if (this.state.errors.includes(error) && error.includes('category')){
      return 'This is a required field'
    }
    return this.state.errors.includes(error) &&
      (this.props.isLargeForm ? getLargeFormTexts(this.state.lang).errorTexts[error] :
      getFormTexts(this.state.lang).errorTexts[error])
  }

  render() {
    const isLargeForm = this.props.isLargeForm
    return (
      <GiftContext.Provider
        value={{
          formData: this.state,
          formContent: {
            texts: isLargeForm ? getLargeFormTexts(this.state.lang) : getFormTexts(this.state.lang),
            agreements: isLargeForm  ? getLargeAgreements(this.state.lang, this.state.isGdpr) : getAgreements(this.state.lang, this.state.isGdpr),
            agreements2: isLargeForm ? getLargeAgreements2(this.state.lang) : getAgreements2(this.state.lang),
          },
          validate: this.validate,
          handleChangeField: this.handleChangeField,
          updateState: this.updateState, // TODO this.setState
          cleanErrors: this.cleanErrors,
          renderError: this.renderError
        }}
      >
        {this.props.children}
      </GiftContext.Provider>
    )
  }
}

export default GiftProvider
